<template>
 <div class="tips-wrap">
    <div class="tips-title">The camera or microphone is currently inaccessible to the browser</div>
    <div style="width:640px;margin:0 auto;">
      <div class="tips-flex">
        <div>1.</div>
        <div>
          <div class="tips-pad">If you'd like to access the MSP's built-in video, please allow the browser to access the camera/microphone.</div>
          <div class="tips-pad">If you encounter any of the following prompts, please click <strong>Allow</strong>.</div>
          <img :src="liuLanQiShouQuan" alt="" class="tips-img">
          <!-- <img :src="weiShouQuan" alt="" class="tips-img"> -->
        </div>
      </div>
      <div class="tips-flex">
        <div>2.</div>
        <div>
          <div class="tips-pad">If not, click the <strong>"lock"</strong> button from the address bar on the top of your browser.</div>
          <img :src="chaKanWeiZhi" alt="" class="tips-img">
        </div>
      </div>
      <div class="tips-flex">
        <div>3.</div>
        <div>
          <div class="tips-pad">Click to check the browser authorization status, make sure the camera/microphone permissions are in the <strong>"allowed"</strong> state.</div>
          <img :src="shouQuanChaKan" alt="" class="tips-img">
        </div>
      </div>
      <div class="tips-flex">
        <div>4.</div>
        <div>
          <div class="tips-pad">After the authorization is completed, please follow the instruction to <strong>reload or refresh</strong> the page.</div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import liuLanQiShouQuan from '@/assets/images/video/liulanqishouquan.png'
import chaKanWeiZhi from '@/assets/images/video/chakanweizhi.png'
import shouQuanChaKan from '@/assets/images/video/shouquanchakan.png'
import weiShouQuan from '@/assets/images/video/weishouquan.png'
export default {
  data () {
    return {
      liuLanQiShouQuan,
      chaKanWeiZhi,
      shouQuanChaKan,
      weiShouQuan
    }
  }
}
</script>

<style lang='less' scoped>
.tips-wrap {
  font-size:18px;
  line-height: 30px;
  color:#333333;
  .tips-title{
    text-align: center;
    padding:39px 0;
    font-size:26px;
    color:#333;
    background-color:#F7F7F7;
    margin-bottom:30px;
    font-weight: 500;
  }
  .tips-flex{
    display:flex;
    padding-bottom:24px;
    .tips-pad{
      padding-left:5px;
    }
  }

}

</style>
